import React from 'react';

const TeamSelector = ({ teams, selectedTeam, onTeamChange }) => {
  return (
    <select
      value={selectedTeam ? selectedTeam.teamId : ''}
      onChange={(e) => {
        const selected = teams.find(team => team.teamId === e.target.value);
        onTeamChange(selected);
      }}
      className="bg-slate-800 text-slate-200 border border-slate-700 px-3 py-1.5 rounded text-sm focus:outline-none focus:border-slate-600"
    >
      <option value="">Select a team</option>
      {teams.map((team) => (
        <option key={team.teamId} value={team.teamId}>
          {team.teamName}
        </option>
      ))}
    </select>
  );
};

export default TeamSelector;